<template>
  <div>
    <!-- <div v-if="loadingStatus">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="ma-2"
          type="card@2"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div> -->

    <v-sheet v-if="news" elevation="2" color="#57bc90" style="min-height: 70vh">
      <v-col
        cols="12"
        md="10"
        sm="10"
        class="mx-auto"
        v-for="article in news"
        :key="article._id"
      >
        <base-title-bar
          elevation="2"
          class="text-center"
          color="#17408B"
          :label="`${article.Title}`"
          icon="mdi-football"
          height="50"
          textProp="pt-2 text-subtitle-1 white--text"
        />

        <!--//* goalies cards.. -->
        <v-card class="mx-auto" rounded elevation="2">
          <v-card-text>
            <span class="caption">
              {{ article.Updated | dayFormat }}
            </span>
            <p class="overline">{{ article.Categories }}</p>
            <p>{{ article.Content }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NflNewsComponent",
  props: {
    news: {
      type: [Array, Object],
      default: () => [],
    },
    Position: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState("NflModule", ["loadingStatus"]),
  },
};
</script>

<style></style>
